import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseInterface } from '../../../models/quotation-model/catalogs/base.model';
import {
  QuoterYearRatePaged,
  QuoterYearRate,
  QuoterYearInsurance,
  QuoterYearInsuranceSelect,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-year.model';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class YearService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getYears(): Observable<BaseInterface[]> {
    return this.http.get<BaseInterface[]>(this.URL_API + '/Year');
  }

  getPromotions(): Observable<BaseInterface[]> {
    return this.http.get<BaseInterface[]>(this.URL_API + '/Year/GetPromotions');
  }

  getPagedYearRates(filters: CommonFilterRequest, YearId: number): Observable<QuoterYearRatePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '')
      .set('YearId', YearId);
    return this.http.get<QuoterYearRatePaged>(this.URL_API + '/Year/GetPagedYearRates', { params });
  }

  upsertQuoterYearRate(upsertYearRate: QuoterYearRate) {
    return this.http.post<CommonResult>(this.URL_API + '/Year/UpsertYearRate', upsertYearRate);
  }

  getYearInsurances(yearId: number): Observable<QuoterYearInsurance[]> {
    return this.http.get<QuoterYearInsurance[]>(
      this.URL_API + '/Year/GetQuoterYearInsurances?yearId=' + yearId,
    );
  }

  upsertYearInsurance(upsertYearInsurance: QuoterYearInsuranceSelect) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Year/UpsertYearInsurance',
      upsertYearInsurance,
    );
  }
}
